module.exports = __webpack_public_path__ + "img/no_heated.6077e76a.svg";